import React from 'react';
import Table from '@mui/material/Table';
import DataTable from '@/components/job-title/DataTable';
import DataGridNode from '@/components/job-title/DataGridNode';

export interface GeneralChartProps {
  title?: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  description?: string | React.ReactNode;
  chartRootClass?: string;
  type: string;
  config?: any;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  seoInfo?: React.ReactNode;
  isCityRankTable?: boolean;
}

const GeneralChart = (props: GeneralChartProps) => {
  const {
    chartRootClass,
    title,
    subTitle,
    description,
    type,
    config,
    footer,
    children,
    seoInfo,
    isCityRankTable = false,
  } = props;
  let chartNode;
  switch (type) {
    case 'table':
      chartNode = <Table {...config} />;
      break;
    case 'dataTable':
      chartNode = <DataTable {...config} isCityRankTable={isCityRankTable} />;
      break;
    case 'dataGrid':
      chartNode = <DataGridNode {...config} />;
      break;
    case 'custom':
      chartNode = children;
      break;
    default:
      chartNode = null;
  }

  return (
    <div
      className={`mt-4 mb-8 rounded-lg${
        chartRootClass ? ` ${chartRootClass}` : ''
      } tablet:mb-12`}
    >
      <div className="chart-header">
        {title && <h2 className="font-semibold text-xl text-black">{title}</h2>}
        {seoInfo && seoInfo}
      </div>
      <div className="mt-4 chart-body bg-white shadow-none rounded-lg">
        {subTitle && (
          <h4 className="font-medium text-base mb-4 mx-5 pt-4 flex items-center tablet:pt-6 tablet:mx-12">
            {subTitle}
          </h4>
        )}
        {description && (
          <div className="my-4 text-xs leading-5 mx-5 tablet:mx-12">
            {description}
          </div>
        )}
        <div className="overflow-hidden">{chartNode}</div>
      </div>
      <div>{footer}</div>
    </div>
  );
};

export default GeneralChart;
